import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './index.module.scss';
import {Container} from 'ui/grid';


export default function Section({theme, slantTop, slantBottom, className, children, ...props}) {

    const sectionClass = classNames(
        styles.Section,
        styles[`Section--theme-${theme}`],
        styles[`Section--slant-${_getSlant(slantTop)}-${_getSlant(slantBottom)}`],
        className,
    );

    return <section className={sectionClass} {...props}>
        <Container>
            <div className={styles.Section__inner}>
                {children}
            </div>
        </Container>
    </section>;
}

const THEMES = [
    'default',  // Transparent
    'white',
    'cover',
    'dark',
    'darker',
];


Section.propTypes = {
    theme: PropTypes.oneOf(THEMES).isRequired,
    slantTop: PropTypes.oneOf(['up', 'down']),
    slantBottom: PropTypes.oneOf(['up', 'down']),
};


Section.defaultProps = {
    theme: 'default',
    slantTop: null,
    slantBottom: null,
};


function _getSlant(value) {
    if ((value === 'up') || (value === 'down')) {
        return value;
    }
    return 'hori';
}


export function CoverSection({style, image, ...props}) {
    const STYLE = {
        backgroundImage: `url(${image})`,
        backgroundPosition: 'top',
        backgroundSize: 'cover',
        ...style,
    };

    return <Section style={STYLE} {...props} />;
}


CoverSection.defaultProps = {
    theme: 'cover',
};



// WEBPACK FOOTER //
// ./src/components/Section/index.js